<template>
  <div class="portal_page">
    <!--使用video标签，配合HLS.js分片播放，样式相对原始-->
    <!-- <video-box :videoConfig="videoConfig"></video-box> -->

    <!--使用ckplayer插件，功能齐全-->
    <!-- <ck-player :containerClassName="containerClassName"
      :ckplayerConfig="ckplayerConfig"
      @playStatus="changePlayStatus"></ck-player> -->

    <!--大视频切片上传-->
    <upload :uploadConfig="uploadConfig"
      @uploadSuccess="uploadSuccess"></upload>
  </div>
</template>
<script>
import { sevUrl } from '@/utils/utils.js'
import videoBox from '@/components/video/video.vue'
import ckPlayer from '@/components/video/ckplayer.vue'
import Upload from '@/components/video/upload.vue'
export default {
  components: { videoBox, ckPlayer, Upload },
  data() {
    return {
      disabledShot: '',
      sourceUrl: '/zwpt-file/portal/largefile/164197625/index.m3u8',
      checkedPontsName: '',
      uploadConfig: {
        limit: 12,//文件数量限制
        autoUpload: false,//是否自动上传
        uploadVideoUrl: sevUrl + '/files:upload',//上传地址
        accept: '.mp4',//文件类型限制
        showFileList: true,//是否显示文件队列
        showPreview: true,//是否显示视频预览模块
        fileList: [
          {
            "hours": 1,
            "videoDuration": 77,
            "fileId": "231f27dd8bbc4b8ca819f4169ff06b7e",
            "fileName": "前半部分.mp4",
            "filePath": "/ftp_portal/2023/1/3/0d7f1a27554249ff843abcb5b63c46a8.mp4",
            "fileType": "mp4",
            "fileUrl": "http://192.162.130.34/zwpt-file/ftp_portal/2023/1/3/0d7f1a27554249ff843abcb5b63c46a8.mp4",
            "name": "前半部分.mp4",
            "url": "http://192.162.130.34/zwpt-file/ftp_portal/2023/1/3/0d7f1a27554249ff843abcb5b63c46a8.mp4"
          }
        ]
      },
      //原生video配合HLS.js的配置
      videoConfig: {
        width: '80px',
        height: '80px',
        autoplay: false,
        loop: true,
        muted: 'muted',
        controls: true,
        controlslist: ''
      },
      //ckplayer的配置
      containerClassName: 'video1',
      ckplayerConfig: {
        container: '.video1',//视频容器的ID
        width: '480px',
        height: '480px',
        plug: 'hls.js',//设置使用hls插件
        video: '/zwpt-file/portal/largefile/164197625/index.m3u8',
        autoplay: true,//自动播放
        // video: [
        //   ['/zwpt-file/portal/largefile/164197625/index.m3u8', "video/*", "超清"],
        //   ['/zwpt-file/portal/largefile/164197625/index.m3u8', "video/*", "高清"],
        //   ['/zwpt-file/portal/largefile/164197625/index.m3u8', "video/*", "流畅"]
        // ],
        // timeScheduleAdjust: 5,//进度条拖拽限制
        seek: 'cookie',//指定跳转到cookie记录的时间，使用该属性必需配置属性cookie
        cookie: 'abcdefg',//cookie名称,请在同一域中保持唯一
      }
    }
  },
  mounted() {
  },
  methods: {
    changePlayStatus(status) { //获取子组件的播放状态
      if (status) {
        this.disabledShot = false
      } else {
        this.disabledShot = true
        this.sourceUrl = ''
        this.checkedPontsName = ''
      }
    },
    uploadSuccess(data) {
      console.log(data)
    }
  }
}
</script>
<style lang="scss" scoped>
.portal_page {
  width: 100%;
  height: 100%;
  /deep/ .scrollbar {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    .el-scrollbar__wrap {
      overflow-x: hidden;
      .el-scrollbar__view {
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/portal/ceshiIndex.vue